import type {
  GetRelatedPersonDetailsPayload,
  GetRelatedPersonDetailsResult,
} from '@shared/services/caregivers/types/getRelatedPersonDetails.types';
import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_RELATED_PERSON_DETAILS } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

export const getRelatedPersonDetails = (builder: BuilderType) =>
  builder.query<GetRelatedPersonDetailsResult, GetRelatedPersonDetailsPayload>({
    query: (data) => ({
      data,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: GET_RELATED_PERSON_DETAILS,
    }),
    transformResponse: (response: GenericApiResponse<GetRelatedPersonDetailsResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
